/* eslint-disable import/no-anonymous-default-export */
import { FontSizes, Icon, IRawStyle, ITextFieldProps, Label, TextField } from '@fluentui/react';
import { Guid } from "guid-typescript";
import * as React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../app/store';
import { FontFaces } from '../../defs/fonts';
import { lock, unlock } from '../../features/operation/lockSlice';
import { itemData, itemUpload, itemDownload } from '../../features/operation/thunks/itemThunk';
import { setResponse } from '../../features/response/responseSlice';
import { security } from '../../features/security/thunks/securityThunk';

const IconRawStyle: IRawStyle = {
    cursor: "pointer",
    display: "block",
    fontSize: 16,
    paddingRight: 9
}

type Props = {
    controller: string,
    name: string,
    page?: any,
    label: string,
    className: string,
    required?: boolean,
    readOnly?: boolean,
    value?: any,
    uploadedGuidFile?: string | undefined,
    oldFileName?: string,
    dowloadable?: boolean,
    modality?: "auto" | "manual",
    onChange?: (name: string | undefined, value: string | number | undefined | number[], required?: boolean | undefined) => void,
    onInit?: (name: string | undefined, value: string | number | undefined, required?: boolean | undefined) => void
}

const GetTextFieldProps = (props: Props, file: File | undefined, onRenderSuffix: () => JSX.Element): Partial<ITextFieldProps> => {
    return {
        label: props.label,
        readOnly: true,
        required: props.required,
        value: file?.name || props.oldFileName,
        autoComplete: "off",
        onRenderSuffix: onRenderSuffix,
        styles: {
            field: {
                cursor: "default"
            },
            fieldGroup: {
                cursor: "default"
            },
            subComponentStyles: {
                label: {
                    root: {
                        fontFamily: FontFaces.montserrat,
                        fontSize: FontSizes.medium,
                        fontWeight: 500,
                        paddingBottom: 2,
                        paddingLeft: 4,
                    },
                },
            },
            suffix: {
                backgroundColor: "unset",
                cursor: "default",
                padding: "1px 0 0",
                selectors: {
                    "label": {
                        color: "unset",
                        padding: 0
                    },
                    "i": IconRawStyle
                }
            },
        }
    };
}

export default (props: Props) => {
    const dispatch: AppDispatch = useDispatch();
    const credential = useSelector(security)?.credential
    const iForm = useSelector(itemData)

    const [file, setFile] = useState<File | undefined>(undefined)
    const [content, setContent] = useState(undefined as any)
    const [uid] = useState(Guid.create().toString())

    const [valueChanged, setvalueChanged] = useState(false)


    const onRenderSuffix = () => {
        if (uploadedGuidFile) {
            return <>
                <Icon iconName="Cancel" onClick={onClickCancel} />
                <Icon iconName="Accept" style={{ cursor: "pointer" }} />
            </>
        }
        return <>
            <Icon iconName="Download" onClick={downloadFile} style={{ cursor: "pointer", background: "transparent", display: (!props.dowloadable || props.dowloadable === undefined || valueChanged) ? "none" : "" }} />
            <Icon iconName="Upload" style={{ cursor: "default", color: '#737373', opacity: 0.5, background: "transparent", display: (!valueChanged) ? "none" : "" }} />
            <Label htmlFor={uid}> <Icon iconName="OpenFolderHorizontal" /></Label >
        </>
    }

    const [uploadedGuidFile, setUploadedGuidFile] = React.useState<string | undefined>(props.uploadedGuidFile)


    useEffect(() => {
        setvalueChanged(false)
        if (props.oldFileName) {
            setFile(new File([], props.oldFileName))
        }
    }, [props.oldFileName])

    useEffect(() => {
        
        if (!!!props?.onInit) {
            return
        }

        var data = iForm.find(i => i.key === props.controller)?.value?.data

        props.onInit(props.name + 'FileID', !!data ? data[props.name + 'FileID'] : undefined, props.required)
        props.onInit(props.name + "Filename", !!data ? data[props.name + 'Filename'] : undefined, props.required)
        props.onInit(props.name, props.value, false)
        setvalueChanged(false)
    }, [])

    useEffect(() => {
        
        setUploadedGuidFile(props.uploadedGuidFile)

        if (props.onInit) {
            props.onInit(props.name + 'FileID', uid ?? props.uploadedGuidFile, props.required)
            props.onInit(props.name + "Filename", file?.name.replace(/\.[^/.]+$/, ""), props.required)
        }
    }, [props.uploadedGuidFile, props.required])

    useEffect(() => {
        
        if (props.onChange) {
            props.onChange(props.name + 'FileID', uploadedGuidFile, props.required)
            props.onChange(props.name + "Filename", file?.name.replace(/\.[^/.]+$/, ""), props.required)
        }
    }, [uploadedGuidFile])

    const onChange = (e: any) => {

        const selectedFile = e.target?.files?.[0];
        if (!selectedFile) return;

        const fileReader = new FileReader();

        fileReader.onloadend = () => setContent(fileReader.result);
        fileReader.readAsArrayBuffer(selectedFile);
        setvalueChanged(true)
        setFile(selectedFile);

        e.target.value = null;
    }

    const onClickCancel = () => {
        setContent(undefined);
        setFile(undefined)
        setUploadedGuidFile(undefined)
    }

    const downloadFile = () => {
        const args = {
            controller: props.controller,
            fileID: props.page?.item?.state?.data?.insuredInvoiceFileID,
            fileName: props.page?.item?.state?.data?.insuredInvoiceFilename,
            token: credential.token
        }

        dispatch(itemDownload(args))
    }

    React.useEffect(() => {
        
        if (props.modality === "manual") {
            if (file && content) {
                props.onChange(props.name, Array.from(new Uint8Array(content)), false);
                props.onChange("FileExtension", file.name, false);

            }
            return
        }
        file && content && onClickUpload()
    }, [file, content])

    const onClickUpload = () => {
        dispatch(lock())

        const args = {
            controller: props.controller,
            lookup: props.controller,
            name: file?.name ?? "",
            type: file?.type ?? "",
            file: Array.from(new Uint8Array(content)),
            idCaller: iForm.find(i => i.key === props.controller)?.value.data.id,
            token: credential?.token
        }

        dispatch(itemUpload(args))
            .then((response: any) => { dispatch(unlock()); return response; })
            .then((response: any) => {
                dispatch(setResponse(response.payload.response.message, response.payload.response.level))
                return response
            })
            .then((response: any) => {
                setUploadedGuidFile(response.payload.data)
            })
            .then(() => {
                setContent(undefined)
            })
            .catch(() => dispatch(unlock()))
    }

    const TextFieldProps: Partial<ITextFieldProps> = GetTextFieldProps(props, file, onRenderSuffix)

    return <>
        <div className={"ms-Grid-col " + props.className} >
            <TextField {...TextFieldProps} />
            <input id={uid} type="file" onChange={onChange} hidden />
        </div>
    </>
};